import TermsConditionsContainer from './TermsConditionsContainer';

export default TermsConditionsContainer;
